export enum SymbolViewEvent {
    WIN_ANIMATION_LOOP = 'onSymbolViewWinAnimationLoop',
    WIN_ANIMATION_COMPLETE = 'onSymbolViewWinAnimationComplete',
}
